module.exports = __webpack_public_path__ + "img/newsinfo_proimg.99bacb75.jpg";